import React,{ useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import DepositMomoForm from '../../components/forms/DepositMomoForm/DepositMomoForm';

const DepositMomo = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="momo-deposit">
      <DepositMomoForm userId={uid} />
    </AuthLayout>
  );
};

export default DepositMomo;
